module.exports = __webpack_public_path__ + "static/media/Mumbai Floods 5.2846dc54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Mumbai Floods 5.jpg
// module id = 158
// module chunks = 0